import {useContext} from "react";
import {useQuery} from '@tanstack/react-query';
import {API_URLS, axiosRequest} from "@lib/axios";
import UserContext from "@lib/contexts/userContext";

/**
 * React Query wrapper for Session participants
 */
const useSessionParticipantsQuery = (event_id) => {
  const { authenticated } = useContext(UserContext);

  return useQuery({
    queryKey: ['participants', event_id],
    queryFn: async () => axiosRequest({
      method: 'GET',
      url: `${API_URLS.PARTICIPANTS}/?event_id=${event_id}&sort=first_name:asc,last_name:asc&with_totals=1`
    }),
    enabled: authenticated,
    refetchOnWindowFocus: false,
    staleTime: 30 * 1000,
    retry: false,
  });
};

export default useSessionParticipantsQuery;
